export default __webpack_public_path__ + "static/media/testimonials-1.bc5e587d.jpg";